export default __webpack_public_path__ + "static/media/voucher.12dde760.svg";